"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PARTS_KEY = '__parts';
exports.defaultMultiply = function (p1, p2) {
    if (!p1 && !p2) {
        return undefined;
    }
    var part1 = typeof p1 === 'undefined' ? {} : p1;
    var part2 = typeof p2 === 'undefined' ? {} : p2;
    var result = {};
    var keys1 = Object.keys(part1);
    var keys2 = Object.keys(part2);
    var keys = keys1.slice();
    for (var _i = 0, keys2_1 = keys2; _i < keys2_1.length; _i++) {
        var key = keys2_1[_i];
        if (keys1.indexOf(key) < 0) {
            keys.push(key);
        }
    }
    for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
        var key = keys_1[_a];
        var val1 = part1[key];
        var val2 = part2[key];
        try {
            var constructor = typeof val1 === 'undefined' ? undefined : val1.constructor;
            var constructor2 = typeof val2 === 'undefined' ? undefined : val2.constructor;
            if ((typeof val1 === 'undefined' && typeof val2 !== 'undefined') ||
                (typeof val1 !== 'undefined' && typeof val2 === 'undefined')) {
                result[key] = typeof val1 === 'undefined' ? val2 : val1;
            }
            else if (constructor !== constructor2) {
                throw new Error("'" + key + "' has different types: " + constructor + " and " + constructor2 + "\nPart1: " + JSON.stringify(p1) + "\nPart2: " + JSON.stringify(p2));
            }
            else {
                if (constructor === Array) {
                    for (var _b = 0, _c = [part1, part2]; _b < _c.length; _b++) {
                        var part = _c[_b];
                        if (part[key] && (part[key].indexOf(undefined) >= 0 || part[key].indexOf(null) >= 0)) {
                            throw new Error(part.constructor.name + "." + key + "=" + JSON.stringify(part[key]) + ". Array with undefined values is forbidden'");
                        }
                    }
                    result[key] = val1.concat(val2);
                }
                else if (constructor === Object) {
                    result[key] = __assign({}, val1, val2);
                }
                else {
                    result[key] = val2;
                }
            }
        }
        catch (e) {
            e.message = "Error while handling key '" + key + "'. " + e.message;
            throw e;
        }
    }
    return result;
};
exports.fold = function (parts, options) {
    var opts = {
        multiply: (options || {}).multiply || exports.defaultMultiply
    };
    var fractal;
    if (!parts || parts.length === 0) {
        fractal = undefined;
    }
    else if (parts.length === 1) {
        fractal = opts.multiply(parts[0], undefined);
    }
    else {
        fractal = parts[0];
        for (var idx = 1; idx < parts.length; idx++) {
            fractal = opts.multiply(fractal, parts[idx]);
        }
    }
    if (fractal) {
        var fractalParts = [];
        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
            var part = parts_1[_i];
            if (part) {
                if (part[PARTS_KEY]) {
                    fractalParts.push.apply(fractalParts, part[PARTS_KEY]);
                }
                else {
                    fractalParts.push(part);
                }
            }
        }
        Object.defineProperty(fractal, PARTS_KEY, {
            value: fractalParts,
            configurable: true
        });
    }
    return fractal;
};
exports.foldTo = function (whole, parts, options) {
    var result = exports.fold(parts, options);
    if (result) {
        for (var _i = 0, _a = Object.keys(result); _i < _a.length; _i++) {
            var key = _a[_i];
            whole[key] = result[key];
        }
        Object.defineProperty(whole, PARTS_KEY, { value: result[PARTS_KEY], configurable: true });
    }
};
exports.getParts = function (whole) {
    return whole && whole[PARTS_KEY] ? whole[PARTS_KEY] : [];
};
//# sourceMappingURL=index.js.map